import { render, staticRenderFns } from "./SheerCurtain2.vue?vue&type=template&id=46897b9a&scoped=true&"
import script from "./SheerCurtain2.vue?vue&type=script&lang=js&"
export * from "./SheerCurtain2.vue?vue&type=script&lang=js&"
import style0 from "./SheerCurtain2.vue?vue&type=style&index=0&id=46897b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46897b9a",
  null
  
)

export default component.exports